const pathWashingtonW = "m375 28c0 4 0 58 0 62 4 0 44 0 44 0l-49 181c0 0-60-240-60-243-3 0-60 0-63 0-1 3-65 243-65 243l-45-181c0 0 41 0 45 0 0-4 0-58 0-62-4 0-178 0-182 0 0 4 0 58 0 62 4 0 40 0 40 0s70 279 71 282c3 0 94 0 98 0 1-3 47-177 47-177s44 174 44 177c3 0 94 0 98 0 1-3 74-282 74-282s36 0 40 0c0-4 0-58 0-62-4 0-132 0-136 0z";

// Used template from react-bootstrap-icon JS
let _excluded = ["color", "size", "title", "className"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const WashingtonW = /*#__PURE__*/forwardRef(function (_ref, ref) {
    let color = _ref.color,
        size = _ref.size,
        title = _ref.title,
        className = _ref.className,
        rest = _objectWithoutProperties(_ref, _excluded);

    return /*#__PURE__*/React.createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 400",
        width: size,
        height: size,
        fill: color,
        className: ['bi', 'bi-washington-w', className].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
        d: pathWashingtonW
    }));
});

WashingtonW.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    className: PropTypes.string
};

WashingtonW.defaultProps = {
    color: 'currentColor',
    size: '1rem',
    title: null,
    className: ''
};

export {WashingtonW}